// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.AlarmEditModal_row__guqaQ {
  display: grid;
  grid-template-columns: 4fr 3fr;
  align-items: center;
}
@media only screen and (max-width: 36rem) {
  .AlarmEditModal_row__guqaQ {
    grid-template-columns: 1fr;
    align-items: flex-start;
  }
}

.AlarmEditModal_label__fospb {
  flex: 1 1;
}

@media only screen and (max-width: 36rem) {
  .AlarmEditModal_input__zzH8F {
    width: 100%;
  }
}

.AlarmEditModal_exclamation__T0Pes {
  color: red;
  margin-left: 1rem;
  font-size: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/components/Alarms/modal/AlarmEditModal.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AChCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAOF;AALE;EALF;IAMI,0BAAA;IACA,uBAAA;EAQF;AACF;;AALA;EACE,SAAA;AAQF;;AAJE;EADF;IAEI,WAAA;EAQF;AACF;;AALA;EACE,UAAA;EACA,iBAAA;EACA,iBAAA;AAQF","sourcesContent":[null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.row {\n  display: grid;\n  grid-template-columns: 4fr 3fr;\n  align-items: center;\n}\n@media only screen and (max-width: 36rem) {\n  .row {\n    grid-template-columns: 1fr;\n    align-items: flex-start;\n  }\n}\n\n.label {\n  flex: 1;\n}\n\n@media only screen and (max-width: 36rem) {\n  .input {\n    width: 100%;\n  }\n}\n\n.exclamation {\n  color: red;\n  margin-left: 1rem;\n  font-size: 1.2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `AlarmEditModal_row__guqaQ`,
	"label": `AlarmEditModal_label__fospb`,
	"input": `AlarmEditModal_input__zzH8F`,
	"exclamation": `AlarmEditModal_exclamation__T0Pes`
};
export default ___CSS_LOADER_EXPORT___;
